"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Menu = (0, _styledComponents.default)(_Menu.default)`
    > .MuiPaper-root {
        color: var(--text-primary-color);
        background-color: var(--bg-color);
        box-shadow: var(--evelation-shadow-1);
    }
`;
exports.Menu = Menu;
Menu.propTypes = _Menu.default.propTypes;